import React from "react";
import OverParkedTable from "../../components/OverParked/OverParkedTable";
import "../../pages/AutomatedDailyReportPage/AutomatedDailyReport.scss";
import MonthlyOnlyTransactionTable from "../../components/MonthlyOnlyTransactionTable/MonthlyOnlyTransactionTable";
import MonthlyOnlyFilteredHeader from "../../components/MonthlyOnlyFilteredHeader/MonthlyOnlyFilteredHeader";

function MonthlyOnlyFilteredPage({
  currentMonthliesIn,
  spaces,
  hourlyTransactionTable,
  overParkedData,
  garageName, 
  utilization
}) {
  const totalSpaces = Number.isFinite(Number(spaces)) ? Number(spaces) : 0;
  const utilizationBase = Number.isFinite(Number(utilization)) ? Number(utilization) : 0;
  const utilizationPct =
    totalSpaces > 0 ? ((utilizationBase / totalSpaces) * 100).toFixed(2) : "0.00";

  return (
    <>
      <MonthlyOnlyFilteredHeader
        currentMonthliesIn={currentMonthliesIn}
        spaces={totalSpaces}
        utilization={utilizationPct}
        garageName={garageName}
      />
      <MonthlyOnlyTransactionTable
        hourlyTransactionTable={hourlyTransactionTable}
      />
      <OverParkedTable
        overParkedData={overParkedData}
        garageName={garageName} />
    </>
  );
}

export default MonthlyOnlyFilteredPage;
